import { exportApi } from "../api/export";
import { useQuery } from "@tanstack/react-query";

export const useGetStandardColumns = () => {

    const { data, isLoading, isSuccess, isError } = useQuery({
        queryKey: ["export-standard-columns"],
        queryFn: () => exportApi.getStandardReport(),
    });

    return {
        data: isSuccess ? data.data : [],
        isLoading,
        isError,
    }

};